import { render, staticRenderFns } from "./MergeEducations.vue?vue&type=template&id=e0fc295c"
import script from "./MergeEducations.vue?vue&type=script&lang=js"
export * from "./MergeEducations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports